import { InvoiceLabel } from '@models/invoice/invoice-label.model';

import { ApiAdapter } from './adapter';

export class InvoiceLabelAdapter extends ApiAdapter<InvoiceLabel> {
  get(json): InvoiceLabel {
    return new InvoiceLabel({
      pattern: json['pattern'],
      params: json['params'],
      translatedValue: json['translated_value'],
    });
  }
}
